import type { ComponentProps } from "react";
import type { ReceiptDraft } from "../../types/receipt";
import { lazy, Suspense } from "react";
import CategorySplitFields from "./CategorySplitFields";
import type { useReceiptInput } from "./use-receipt-input";

const ReceiptCategorySplit = lazy(() => import("../../components/ReceiptCategorySplit"));

export default function EntryAllocationFields({ receipt, changePlan, ...props }: ComponentProps<typeof CategorySplitFields> & {
  receipt?: ReceiptDraft;
  changePlan: ReturnType<typeof useReceiptInput>["changePlan"];
}) {
  return receipt ? <><Suspense fallback={<p className="muted">Loading receipt categories…</p>}><ReceiptCategorySplit receipt={receipt} expense={props.input} options={props.entryOptions} disabled={props.disabled} onChange={changePlan} /></Suspense>
    {(!receipt.categorySplit || receipt.categorySplit.mode === "off") && <CategorySplitFields {...props} />}</>
    : <CategorySplitFields {...props} />;
}
